// Feature flag helper.
//
// Flags are sourced from Vite env vars named `VITE_FEATURE_<UPPER_FLAG>`.
// A flag is enabled when the env value is one of: 'true', '1', 'on'
// (case-insensitive). All other values, including missing, mean disabled.

import { readEnv } from './env';

export type FeatureFlags = {
  htmlRendering: boolean;
  // Controls legacy upload surfaces separately from the chat composer attachment flow.
  fileUploads: boolean;
  slack: boolean;
  schedules: boolean;
};

const ENV_PREFIX = 'VITE_FEATURE_';

const TRUTHY = new Set(['true', '1', 'on']);

function flagToEnvName(flag: keyof FeatureFlags): string {
  // camelCase -> UPPER_SNAKE: htmlRendering -> HTML_RENDERING
  const snake = flag.replace(/[A-Z]/g, (ch) => `_${ch}`).toUpperCase();
  return `${ENV_PREFIX}${snake.replace(/^_/, '')}`;
}

export function isFeatureEnabled(flag: keyof FeatureFlags): boolean {
  const value = readEnv(flagToEnvName(flag));
  if (typeof value !== 'string') {
    return false;
  }
  return TRUTHY.has(value.trim().toLowerCase());
}
